import {LoadPageDataParams, PageParamsOnFunctionsResolverInterface} from '@/src/core/domain/page'
import merge from 'lodash/merge'
import {inject, injectable} from 'inversify'
import type {FetchOptionsFactory} from '../../domain/page/functions/fetch/types'
import {DI} from '@/src/config/di/types'
import {isMobile} from '@/src/shared/utils/functions'
import type {IInstrumentationService} from '@/src/ports/services/monitoring/instrumentation'

@injectable()
export class PageParamsOnFunctionsResolver implements PageParamsOnFunctionsResolverInterface {
  @inject(DI.IInstrumentationService)
  instrumentation!: IInstrumentationService

  @inject(DI.FetchOptionsFactory)
  fetchOptionsFactory!: FetchOptionsFactory

  async do(
    pageParams: LoadPageDataParams,
    session: Nullable<Session>,
  ): Promise<LoadPageDataParams> {
    let params = pageParams

    if (pageParams.transformKey) {
      const fetchOptionsFactory = this.fetchOptionsFactory(pageParams.transformKey)

      if (fetchOptionsFactory) {
        const resolveFetchOptionsFn = fetchOptionsFactory.create(pageParams)
        const fetchBehavior = await resolveFetchOptionsFn(session)
        params = merge(pageParams, fetchBehavior)
      }
    }

    if (isMobile()) {
      params.suspendUntilClientReady = typeof window === 'undefined'
    }

    return params
  }
}
